import { CreatedInterfaces } from 'interfaces';
import { IContactCenterLog } from 'interfaces/contact-center-log';
import { PaginationResponse } from 'interfaces/common/PaginationResponse';
import { isError } from 'lodash';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'contact-center-logs';

const useGetContactCenterLogs = (
  cardholderId: string,
  startDate: string,
  endDate: string,
  pageSize: number,
  pageIndex: number
) => {

  const [{  data, error, loading }, refresh] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/customer-service-log?cardholder=${cardholderId}&page=${pageIndex-1}&size=${pageSize}&start_date=${startDate}Z&end_date=${endDate}Z`,
  });


  return {
    data: data?.data,
    pageInfo: data?.meta,
    refresh,
    isLoading: loading,
    isError: error,
  }
};

export default useGetContactCenterLogs;
